(() => {
  'use strict';
  if (window.bockmannColorOrder) return;
  const officialPalette = {
  "Silver metallic": {
    "hex": "#A5A5A4",
    "neutralSilver": true,
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_se1v1ok7jd6vhdcqao00b14t32/-S150x100-FPNG",
    "metallic": true
  },
  "Röd metallic": {
    "hex": "#71242B",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_k3vke94p8l3bd234mhbennlc6b/-S150x100-FPNG",
    "metallic": true
  },
  "Grön metallic": {
    "hex": "#0B423B",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_2vmtoivf4170fe4nuluurdic0g/-S150x100-FPNG",
    "metallic": true
  },
  "Mörkblå metallic": {
    "hex": "#112533",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_j89puibqlh1jl64qj3015s3l1v/-S150x100-FPNG",
    "metallic": true
  },
  "Mörkbrun metallic": {
    "hex": "#562F28",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_kv1ck6j429403bkokh1j34i84l/-S150x100-FPNG",
    "metallic": true
  },
  "Skiffergrå metallic": {
    "hex": "#68676E",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_cmfcl1f9797cv2e0tnrdndre4o/-S150x100-FPNG",
    "metallic": true
  },
  "Antracit metallic": {
    "hex": "#0D0F11",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_j3po927mgp2314esiper6u5430/-S150x100-FPNG",
    "metallic": true
  },
  "Vit": {
    "hex": "#FDFDFD",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_6h5uc2tu1l0f77tk5vl4v43p1t/-S150x100-FPNG",
    "metallic": false
  },
  "Gul": {
    "hex": "#EEE822",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_abbf6ke57l3rd5j15m6gjajm1u/-S150x100-FPNG",
    "metallic": false
  },
  "Djuporange": {
    "hex": "#F58829",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_ggrl8nik4538ldf1a902agvd28/-S150x100-FPNG",
    "metallic": false
  },
  "Flamröd": {
    "hex": "#EE362E",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_fk46l3cgft1grfpk3t4btsae7u/-S150x100-FPNG",
    "metallic": false
  },
  "Magenta": {
    "hex": "#DA4080",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_bb72hl9nfh55nf97mjuf2aj86k/-S150x100-FPNG",
    "metallic": false
  },
  "Frozen Berry": {
    "hex": "#760648",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_02geuf0dad0op6vi44r9tinm6t/-S150x100-FPNG",
    "metallic": false
  },
  "Gulgrön": {
    "hex": "#37B54A",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_m9qbm70rh90vt8j9r5unsmgl7d/-S150x100-FPNG",
    "metallic": false
  },
  "Royalblå": {
    "hex": "#11236B",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_g61ggnto8h1d94e9v7uistq17i/-S150x100-FPNG",
    "metallic": false
  },
  "Silvergrå": {
    "hex": "#8C969D",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_65blj9e14l0ej22014ncbjh55i/-S150x100-FPNG",
    "metallic": false
  },
  "Skiffergrå": {
    "hex": "#4F5358",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_u1b6vedmhp7vt1tar3ugnlp47s/-S150x100-FPNG",
    "metallic": false
  },
  "Charity Green": {
    "hex": "#164F32",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_m7aihbsd911m531116qf35192v/-S150x100-FPNG",
    "metallic": true
  },
  "Silk Stone metallic": {
    "hex": "#CCC5B3",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_lffohv455104rdpdte0b4mnc3l/-S150x100-FPNG",
    "metallic": true
  },
  "Antracit": {
    "hex": "#33373a",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_tnipl7jpf932vafc7jengb1i3h/-S150x100-FPNG",
    "metallic": false
  },
  "Grå": {
    "hex": "#878b8e",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_cjcv7tf77t24l0q9a0gn2a2g6a/-S150x100-FPNG",
    "metallic": false
  },
  "Granitgrå": {
    "hex": "#878b8e",
    "swatch": "https://d1tqvb5h42deiw.cloudfront.net/image/774305612601/image_cjcv7tf77t24l0q9a0gn2a2g6a/-S150x100-FPNG",
    "metallic": false
  }
};
  function applyOfficialPalette(root) {
    if (!root) return;
    root.querySelectorAll('.bock-color-group input[type="radio"]').forEach(input => {
      const color = officialPalette[input.value.replace('Silk-Stone','Silk Stone')];
      if (!color) return;
      input.dataset.color = color.hex;
      input.dataset.metallic = String(color.metallic);
      const chip = input.closest('label')?.querySelector('.bock-chip');
      if (!chip) return;
      chip.classList.toggle('metallic', color.metallic);
      chip.style.setProperty('--bock-color', color.hex);
      chip.style.backgroundColor = color.hex;
      // Keep the manufacturer's flakes visible at 32px, with a soft metallic reflection.
      chip.style.backgroundImage = color.metallic
        ? 'linear-gradient(135deg, rgba(0,0,0,.22) 0%, rgba(255,255,255,.08) 25%, rgba(255,255,255,.42) 43%, rgba(255,255,255,.06) 57%, rgba(0,0,0,.24) 79%, rgba(255,255,255,.16) 100%), url("' + color.swatch + '")'
        : 'url("' + color.swatch + '")';
      chip.style.backgroundSize = color.metallic ? '100% 100%, 96px 64px' : 'cover';
      chip.style.backgroundPosition = 'center';
      chip.style.backgroundRepeat = 'no-repeat';
      // Neutralize the green cast in the source silver swatch; retain its metallic flakes.
      chip.style.filter = color.neutralSilver ? 'grayscale(1)' : '';
    });
  }

  const order = [
    'Utan färgat tillval', 'Standard svart',
    'Silver metallic', 'Röd metallic', 'Grön metallic', 'Mörkblå metallic',
    'Mörkbrun metallic', 'Skiffergrå metallic', 'Antracit metallic', 'Vit',
    'Gul', 'Djuporange', 'Flamröd', 'Magenta', 'Frozen Berry', 'Gulgrön',
    'Royalblå', 'Silvergrå', 'Skiffergrå', 'Charity Green', 'Silk Stone metallic'
  ];
  const ranks = new Map(order.map((name, index) => [name, index]));
  const rank = name => ranks.get(name) ?? order.length;
  const sort = (parent, items, value) => {
    const sorted = [...items].sort((a, b) => rank(value(a)) - rank(value(b)));
    if (sorted.some((item, index) => item !== items[index])) {
      sorted.forEach(item => parent.append(item));
    }
  };
  function normalize(scope = document) {
    applyOfficialPalette(scope);
    scope.querySelectorAll('.bock-color-group .bock-swatches, .bp-color .bp-swatches').forEach(group => {
      const labels = [...group.children].filter(el => el.matches('label'));
      sort(group, labels, label => label.querySelector('input')?.value);
    });
    scope.querySelectorAll('.bp-color select').forEach(select => {
      const selected = select.value;
      sort(select, [...select.options], option => option.value);
      select.value = selected;
    });
  }
  window.bockmannColorOrder = { normalize };
  window.BockmannColorPicker = { normalize, palette: officialPalette };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => normalize(), { once: true });
  else normalize();
  document.addEventListener('shopify:section:load', event => normalize(event.target));
})();

